export var topConfig = function topConfig(self) {
  return [{
    label: '1',
    name: self.$t('219') // 置顶
  }, {
    label: '0',
    name: self.$t('224')
  }];
};
export var btnConfig = function btnConfig(self) {
  return [{
    label: '1',
    name: self.$t('162') // 所有人
  }, {
    label: '2',
    name: self.$t('864')
  }, {
    label: '3',
    name: self.$t('865')
  }];
};
export var mustReadConfig = function mustReadConfig(self) {
  return [{
    label: '0',
    name: self.$t('1800') // 否
  }, {
    label: '1',
    name: self.$t('1801')
  }];
};
export var categoryConfig = function categoryConfig(self) {
  return [{
    label: '1',
    name: self.$t('1694') // 普通消息
  }, {
    label: '4',
    name: self.$t('1695') // 签字消息
  }];
};

// 发布状态筛选项：默认空，已发布(1)/已撤销(2)
export var statusFilterConfig = function statusFilterConfig(self) {
  return [{
    label: '1',
    name: self.$t('213')
  }, {
    label: '2',
    name: self.$t('93')
  }];
};